module.exports = "<div class=content-table role=presentation> <div class=content-cell> <forgotten></forgotten> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/login/forgotten/forgotten.html
// module id = 486
// module chunks = 0